import React from 'react'
import {
  TRADE_PARTNER_PURCHASE_ORDER_DOCUMENT,
  TRADE_PARTNER_SAMPLE_DOC_STATEMENT_OF_ACCOUNTS,
  UploadFormWrapper,
} from '@modifi/plugin-onboarding'
import {useTranslation} from '@modifi/plugin-i18n'
import {CustomerDialogButtonRow, DangerAlert, H5} from '@modifi/ui'
import {uploadFormComponents} from '@modifi/plugin-documents'
import {Form, FormActionsContext, FormDataContext, SubmitBehavior} from '@modifi/plugin-forms'

import {CompanyDocumentUpload} from '../../../../../plugins/onboarding'
import {EntityFormData} from '../../../../../types/common'

export type HighLimitDocUploadDialogProps = {
  params: {
    externalTradePartnerId: string
  }
  formData: EntityFormData
  savePending: boolean
  errorMessage?: string
  submit: (changes: Record<string, unknown>, externalTradePartnerId: string) => void
  hideBuyerForm: () => void
  closeDialog: () => void
}

const HighLimitDocUploadDialog: React.FC<HighLimitDocUploadDialogProps> = ({
  params,
  formData,
  savePending,
  errorMessage,
  submit,
  hideBuyerForm,
  closeDialog,
}) => {
  const {externalTradePartnerId} = params
  const {t} = useTranslation('charon')

  const handleCancel = () => {
    hideBuyerForm()
    closeDialog()
  }

  return (
    <>
      <H5 textAlign="center" mb={24}>
        {t('dialog.seller-trade-partner.high-limit-doc-upload.headline')}
      </H5>
      {errorMessage && <DangerAlert>{errorMessage}</DangerAlert>}
      <Form
        isLoading={savePending}
        defaultValues={{}}
        initialValues={formData?.initialValues}
        onSubmit={changes => submit(changes, externalTradePartnerId)}
        submitBehavior={SubmitBehavior.SUBMIT_DISABLED_UNLESS_VALID}
        initialFormIsValid
      >
        <UploadFormWrapper
          t={t}
          name="sampleDocuments"
          uploadFormComponent={CompanyDocumentUpload}
          inputFieldNames={[
            TRADE_PARTNER_PURCHASE_ORDER_DOCUMENT,
            TRADE_PARTNER_SAMPLE_DOC_STATEMENT_OF_ACCOUNTS,
          ]}
          components={uploadFormComponents}
          externalCompanyId={externalTradePartnerId}
          multiple
        />
        <FormDataContext.Consumer>
          {({data}) => {
            const hasBothDocs =
              new Set(
                // @ts-expect-error types to be fixed
                (data?.sampleDocuments?.added || data?.sampleDocuments)?.map(
                  (file: {documentType: any}) => file.documentType
                )
              ).size > 1

            return (
              <FormActionsContext.Consumer>
                {ctx => (
                  <CustomerDialogButtonRow
                    loading={hasBothDocs ? savePending : false}
                    expectedSubmitDuration={2000}
                    isCancelPending={ctx.hasChanges && !hasBothDocs ? savePending : false}
                    expectedCancelDuration={2000}
                    canSubmit={
                      hasBothDocs &&
                      ctx.canSubmit &&
                      ctx.hasChanges &&
                      !ctx.validationPending &&
                      !savePending
                    }
                    onSubmitClick={ctx.submit}
                    submitText={t('dialog.seller-trade-partner.high-limit-doc-upload.cta-submit')}
                    hasCancel
                    canCancel={!savePending}
                    onCancelClick={ctx.hasChanges ? ctx.submit : handleCancel}
                    cancelText={t('dialog.seller-trade-partner.high-limit-doc-upload.cta-cancel')}
                  />
                )}
              </FormActionsContext.Consumer>
            )
          }}
        </FormDataContext.Consumer>
      </Form>
    </>
  )
}

export default HighLimitDocUploadDialog
